/** @jsxImportSource @emotion/react */

export const GlobalPage = () => {
  return <div>Placeholder Global Page</div>;
};
